<script>
    export let row = {};
    export let col;
    export let options;
    import {PATH_PREFIX} from "../../../apiUrls";

    const QUALITY_QUESTION_ICON_LOCATION = `${PATH_PREFIX}/sw/static/common/images/QualityQuestion.png`;
</script>

<style>
    .questions_count {
        color: #51A0D5;
        vertical-align: text-top;
    }
</style>


{#if row.quality_questions_count > 0}
    <span class="questions_count">{row.quality_questions_count}</span><img alt="sw" src={QUALITY_QUESTION_ICON_LOCATION} width="27" height="25">
{/if}

